import React from 'react'

import { Box, Item, Text } from '@factorialco/deprecated-design-system'
import { A3innuvaContractsContractTypesFragment } from 'generated/resources/graphql'

import type { WizardData } from 'modules/marketplace/lib/types'
import { AgreementItem } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/Agreement/AgreementItem'

interface AgreementByLegalEntityProps {
  name: string | null | undefined
  agreements: A3innuvaContractsContractTypesFragment[]
  options: Item[]
  onSelect: (agreementId: string, value: string, label: string) => void
  data: WizardData
}

export const AgreementByLegalEntity: React.FC<AgreementByLegalEntityProps> = ({
  name,
  agreements,
  options,
  onSelect,
  data,
}) => {
  const findAgreement = (agreementId: string) => {
    const selection = data.answers[`contract_type_${agreementId}`]
    if (!selection) return ''

    return options.find((option) => option.value === selection)?.label || ''
  }

  return (
    <Box gap="s24">
      {name && <Text.Header2>{name}</Text.Header2>}
      {agreements.map((agreement) => (
        <AgreementItem
          key={agreement.id}
          agreement={agreement}
          selectedValue={findAgreement(agreement.id)}
          options={options}
          onSelect={(value, label) => onSelect(agreement.id.toString(), value, label)}
        />
      ))}
    </Box>
  )
}
